'use client'

import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'

const AuthModalContext = createContext(undefined)

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext)
  if (!ctx) throw new Error('useAuthModal must be used within AuthModalProvider')
  return ctx
}

export const AuthModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [initialView, setInitialView] = useState('login')
  const [isRequired, setIsRequired] = useState(false) // Track if login is required

  const openAuth = useCallback((view = 'login', required = false) => {
    setInitialView(view)
    setIsRequired(required)
    setIsOpen(true)
  }, [])

  const closeAuth = useCallback((force = false) => {
    // Allow closing if it's not required or if force is true
    if (!isRequired || force) {
      setIsOpen(false)
      setIsRequired(false) // Reset required state when closing
    }
  }, [isRequired])

  return (
    <AuthModalContext.Provider value={{ isOpen, initialView, openAuth, closeAuth, isRequired }}>
      {children}
    </AuthModalContext.Provider>
  )
}
